export default __webpack_public_path__ + "dist/media/Opportunities.8bdb6085.svg";